import React, { useState } from 'react'
import { requestAPI } from '../data/api.js'
import Input from '../generic/Input.js'
import Button from '../generic/Button.js'
import assignClientToUser from './assignClientToUser.js'

export default function AddPartner(props) {
	const { userId } = props
	const [name, setName] = useState('')
	const [shortName, setShortName] = useState('')
	const [whitelist, setWhitelist] = useState('')

	const handleAddPartnerClicked = async () => {
		const response = await addPartner(name, shortName, whitelist)
		if (response.code) {
			return alert(response.message)
		}
		await assignClientToUser(userId, response.clientId)
	}

	return (
		<div className='container'>
			<h1 style={{marginTop: '30px', marginBottom: '20px'}}>Add Partner</h1>
			<h3>Name</h3>
			<Input
				name='name'
				value={name}
				onChange={e => setName(e.target.value)}
			/>
			<h3>Short name</h3>
			<Input
				name='short-name'
				value={shortName}
				onChange={e => setShortName(e.target.value)}
			/>
			<h3>Whitelist (optional)</h3>
			<p>Example: example.com, example.com/some/url</p>
			<Input
				name='whitelist'
				value={whitelist}
				onChange={e => setWhitelist(e.target.value)}
			/>
			<Button onClick={handleAddPartnerClicked}>Add</Button>
		</div>
	)
}

function addPartner(name, shortName, whitelist) {
	return requestAPI(`/partner-creation`, 'POST', { name, shortName, whitelist })
}
